import {
  relationType,
  uid,
  capitalize,
  detailsFields
} from '../igao/utils/index.js'

export const onTemplateChange = (e, ref, _item, lists) => {
  const item = { ..._item }
  const template = item.template
    ?.replaceAll("<span style='font-weight: bold;'>%%", '{')
    .replaceAll('%%</span>', '}')
  const allMarkDown =
    template?.match(/{[^{}]*}/g) ||
    []?.filter(md =>
      lists?.relations?.find(
        r => r.name === md.replace('{', '').replace('}', '')
      ))

  if (ref && e) {
    const { selectionEnd, selectionStart } = ref.current
    const cursorPos = ref.current?.selectionEnd || 0
    let wordIndex

    if (e.keyCode === 8 || e.charCode === 8) {
      if (selectionEnd === selectionStart && template[cursorPos - 1] === '}') {
        e.preventDefault()
        const markDownArray = allMarkDown.map(mark => {
          if (template.lastIndexOf(mark) + mark.length === cursorPos) {
            wordIndex = template.lastIndexOf(mark)
            return mark
          }
          return null
        })
        const markDown = markDownArray.filter(mark => mark !== null)[0]
        if (markDown) {
          item.template = template?.replace(markDown, '')
          setTimeout(() => {
            if (ref) {
              ref.current.selectionStart = wordIndex - 1

              ref.current.selectionEnd = wordIndex - 1
            }
          }, 0)
        }
      }
    }
  }

  item.relations = allMarkDown.map(markDown => {
    const key = markDown.replace('{', '').replace('}', '')
    if (key.length > 0) {
      const newRelation = {
        id: uid(),
        key,
        label: capitalize(key),
        type: relationType(key)
      }
      if (!detailsFields.includes(key)) newRelation.values = []
      else newRelation.value = ''
      return newRelation
    }
    return null
  }).filter(r => r?.key)
  return item
}

export const getNewItem = (newItem, lists) => {
  if (newItem.igao) {
    return {
      id: newItem.id,
      label: newItem.label,
      goal: newItem.goal,
      draft: true,
      type: newItem?.relations?.length > 0 ? 'dynamic' : 'static',
      unfavorable: newItem.unfavorable,
      hidden: false,
      domain: lists.domain.find(d => d.id === newItem.domain).id,
      template: newItem.template
        .replaceAll('{', "<span style='font-weight: bold;'>%%")
        .replaceAll('}', '%%</span>'),
      relations: newItem.relations || [],
      details: [
        {
          id: 1,
          type: 'select',
          label: 'assignee',
          key: 'assignee',
          values: []
        },
        {
          id: 2,
          type: 'select',
          label: 'status',
          key: 'status',
          values: []
        },
        {
          id: 3,
          type: 'input',
          label: 'comment',
          key: 'comment',
          value: ''
        }
      ]
    }
  }
  if (!newItem.igao) {
    return {
      id: newItem.id,
      label: newItem.label,
      answer: null,
      hidden: false,
      draft: true,
      type: 'plain'
    }
  }
  return null
}

export const hashLocationChange = (nextLocation, router) => {
  router.push(nextLocation)
}

export const discardOnRouteChange = (path, setTab, router) => {
  setTab(null)
  router.push({
    pathname: path,
    state: { forced: true }
  })
}
